module.exports = "<div class='menu'\n    *ngIf='utils.authenticated'>\n  <a routerLink=\"/projects\"\n      class='first'\n      routerLinkActive=\"current\"\n      [routerLinkActiveOptions]=\"{ exact: true }\">Projects</a>\n\n  <a routerLink=\"/documentation\"\n      routerLinkActive=\"current\"\n      [routerLinkActiveOptions]=\"{ exact: false }\">Documentation</a>\n\n  <a routerLink=\"/bookmarks\"\n      routerLinkActive=\"current\"\n      [routerLinkActiveOptions]=\"{ exact: false }\">Bookmarks</a>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/main-menu/main-menu.component.html
// module id = 429
// module chunks = 0